export const DEFAULT_CONTEXT_MENU_CLASS = 'ag-charts-context-menu';
